import React, {Component} from 'react';

class Btn extends Component {

    constructor(props) {
        super(props)

        this.state = {
            active: false
        }
    }

    handleClick(e) {

        this.props.handleClick(e)

        this.setState({
            active: true
        })

        setTimeout(() => {
            this.setState({
                active: false
            })
        }, 200)
    }

    render() {

        let item = this.props.item

        return (
            <div className={this.state.active ? 'btn active' : 'btn'}
                 style={{width: item.name == '=' ? 104 : 50, borderRadius: item.name == '=' ? 30 : 100}}
                 onClick={(e) => {
                     this.handleClick(e)
                 }}>{item.name}</div>
        );
    }
}

export default Btn;